export var SecurityLevel;
(function (SecurityLevel) {
    SecurityLevel[SecurityLevel["LOWEST"] = 1] = "LOWEST";
    SecurityLevel[SecurityLevel["LOWER"] = 2] = "LOWER";
    SecurityLevel[SecurityLevel["LOW"] = 3] = "LOW";
    SecurityLevel[SecurityLevel["BELOW_NORMAL"] = 4] = "BELOW_NORMAL";
    SecurityLevel[SecurityLevel["NORMAL"] = 5] = "NORMAL";
    SecurityLevel[SecurityLevel["ABOVE_NORMAL"] = 6] = "ABOVE_NORMAL";
    SecurityLevel[SecurityLevel["HIGH"] = 7] = "HIGH";
    SecurityLevel[SecurityLevel["HIGHER"] = 8] = "HIGHER";
    SecurityLevel[SecurityLevel["HIGHEST"] = 9] = "HIGHEST";
})(SecurityLevel || (SecurityLevel = {}));
//# sourceMappingURL=definitions.js.map